import Player from '@vimeo/player';

document.addEventListener('DOMContentLoaded', () => {
    [...document.querySelectorAll('.responsive-video')].map(el => {
        el.addEventListener('click', (event) => {
            console.log("clicked video");
            event.preventDefault();
            event.currentTarget.classList.add('is-hidden');
            let iframe = el.querySelector('iframe'),
                player = new Player(iframe);
            player.play();


            // player.on('pause', function() {
            //     let video = player.element.closest('.responsive-video');
            //     video.classList.remove('is-hidden');
            //     event.currentTarget.classList.toggle('is-hidden');
            // });
        });
    });
});